import { datatypes, inputTypes } from "data/globalData";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";

export const tableColumns = {
	category: {
		name: "Category",
		key: "category",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	price: {
		name: "Price",
		key: "price",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	value: {
		name: "Value",
		key: "value",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};
export const otherChargesRowTypes = {
	margin_plus_oh: {
		name: "Margin + OH",
		key: "margin_plus_oh",
		value_type: "percent",
	},
	wastage: {
		name: "Wastage",
		key: "wastage",
		value_type: "percent",
	},
	transport_charges: { name: "Transport Charges", key: "transport_charges" },
	gpt: { name: "GPT", key: "gpt" },
};

export const otherChargesDefaultData = [
	{
		id: 1,
		category: otherChargesRowTypes.margin_plus_oh.key,
		price: 10,
		value: 0,
	},
	{
		id: 2,
		category: otherChargesRowTypes.wastage.key,
		price: 2,
		value: 0,
	},
	{
		id: 3,
		category: otherChargesRowTypes.transport_charges.key,
		price: 0,
		value: 0,
	},
	{
		id: 4,
		category: otherChargesRowTypes.gpt.key,
		price: 0,
		value: 0,
	},
];
export const defaultTotalRow = {
	id: "TOTAL",
	category: "TOTAL",
	price: null,
	value: 341,
};

export const checkForTotalColumn = (row) => {
	if (row.id === "TOTAL" || row.trims_id === "TOTAL" || row?.[tableColumns.category.key] === "TOTAL") return true;
	return false;
};
export const calculateTotalRow = (allRows) => {
	// let price = 0;
	let value = 0;
	allRows?.forEach((row) => {
		// if (!isNaN(row?.[tableColumns.price.key])) price += +row?.[tableColumns.price.key];
		if (!isNaN(row?.[tableColumns.value.key])) value += +row?.[tableColumns.value.key];
	});
	console.log("dsmnfbdskfbksd", allRows, value);

	return {
		...defaultTotalRow,
		//  [tableColumns.price.key]: price,
		[tableColumns.value.key]: value,
	};
};

export const calculateMarginPlusOhValue = (row, garmentTotal = 0) => {
	return roundDecimalValueUptoTwoDigit(((Number(row?.price) ?? 0) / 100) * garmentTotal);
};
export const calculateWastagePercentValue = (row, garmentTotal = 0) => {
	return roundDecimalValueUptoTwoDigit(((Number(row?.price) ?? 0) / 100) * garmentTotal);
};
export const calculateTansportChargesValue = (row, garmentTotal = 0) => {
	return roundDecimalValueUptoTwoDigit(Number(row?.price) ?? 0);
};
export const calculateGptValue = (row, totalByQty = 0) => {
	if (!totalByQty) return 0;
	return roundDecimalValueUptoTwoDigit((Number(row?.price) ?? 0) / totalByQty ?? 0);
};
